export * from './social-link.interface';
export * from './auth-module-config.interface';
